module.exports = __webpack_public_path__ + "img/icon_search_cancel.a76717a1.svg";